<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/TomilolaAdedewe.jpg" alt="Tomilola Adedewe">
          </figure>
       <div class="finger-print"><img src="@/assets/images/fingerprints/fingerprint-one.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Tomilola Adedewe</h2>
      
      <p class="job-title">Student</p>


      <p class="profile-statement-interviewer">Tell us a little bit about yourself </p>

      <p>I have always loved spending time with my family and friends. This is because I love creating experiences with people who are always present in my life. I also love being busy and staying organised, as it helps me feel active and in control of what happens around me.</p>

      <p class="profile-statement-interviewer">Why Man Met University?</p>

      <p>I am at MMU because I wanted to go to a diverse university where I would meet many other black students. Also, MMU is one of the few nearby universities that offer my course – Business Technology.</p>

      <p class="profile-statement-interviewer">What is something that you love about your culture or heritage? </p>

      <p>
        Something I love about being from the tribe Yoruba, one of many tribes in Nigeria, is the respect and loyalty we have with one another. I admire this about my tribe because such qualities are
        becoming more difficult to find in people today. Being brought up in a home where this is a priority makes me feel privileged and fortunate.
      </p>

      <p class="profile-statement-interviewer">What does it look like to bring your whole self to your education? </p>

      <p >Education has always been something I’ve been raised to believe in, so having this understanding growing up that education is important has made me overcome the challenges and stresses that come with going to university. Therefore, bringing my whole self to my education is not always easy, but I am driven by the end goal that I will have a degree in hand and much gathered knowledge and experience.</p>

      <p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students? </p>

      <p>Something I would find very interesting is for the University to host a culture day. This would be an amazing opportunity for us to see how diverse the University is and a great way for students to learn more about each other’s ethnic backgrounds in a safe and inclusive environment.</p>

      <p class="profile-statement-interviewer">What are you most proud of?</p>

      <p>I am proud of how I have not let my personal challenges and situations interfere with me achieving the grades I want. This makes me very happy because I have been in many dilemmas, whereby I have the right to say ‘I cannot take this assignment on this block’ or that I must submit late. However, I have not done this because, no matter the dilemma, I remind myself that the future Tomi will thank me later for pulling through.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  .profile-container {
  flex-direction: row-reverse;
  }

  .profile-portrait-container {
    justify-content: flex-end;

      & figure {
      text-align: right;
    }
  }

</style>